import { inject, injectable } from 'inversify';
import CategoriesRepository from 'src/features/categories/data/CategoriesRepository';

@injectable()
class GetCategoriesByStoreUseCase {
  @inject(CategoriesRepository)
  private categoriesRepository!: CategoriesRepository;

  async execute({ storeSlug }: { storeSlug: string }) {
    return await this.categoriesRepository.getByStoreSlug({ storeSlug });
  }
}

export default GetCategoriesByStoreUseCase;
